import { webcamAtom, myFaceAtom, isFaceDetectReadyAtom, pageAtom, nftIDAtom } from '../../State';
import { useAppMessage, useParticipantProperty } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useEffect, useRef, useState, useCallback } from 'react';
import './Live2d.css';
import { Vector, Face } from 'kalidokit';

export default function Live2dDetectOther({ id, modelRef }) {
  //Daily系
  const userName = useParticipantProperty(id, 'user_name');

  //その他State
  const [faceValue, setFaceValue] = useState([0, 0, 0, 0, 0, 0, 0, 0]);

  //メッセージ受信をリッスン（初回ロードのみ設定)
  useAppMessage({
    //下記のCallbackないは他のアバターからでも取得されるが、レンダー自体はされない
    onAppMessage: useCallback((ev) => {
      //イベントタイプがfaceで送信先のUserIDと現在のUserIDが一致するとき
      if (ev.data.type == 'face' && ev.fromId == id) {
        setFaceValue(ev.data.face);
      }

      //マウスモード変更の場合
      // if (ev.data.type == 'isFaceTracking' && ev.fromId == id) {
      //   setIsFaceTracking(ev.data.mode);
      // }
    }, []),
  });

  //ディフォルトのアイドルモーションを設定
  function setIdleMotion() {
    //モデルがロードされていない場合
    if (modelRef.current == null) {
      //１秒後に再度確認
      setTimeout(() => {
        setIdleMotion();
      }, 1000);

      return;
    }

    //モーションをアクティングモードに変更
    modelRef.current.internalModel.motionManager.groups.idle = 'Idle';
  }

  useEffect(() => {
    setIdleMotion();
  }, []);

  useEffect(() => {
    if (modelRef.current == null) return;

    const internalModel = modelRef.current.internalModel;
    const coreModel = internalModel.coreModel;

    //自動的にまばたきをするかどうかの設定
    modelRef.current.internalModel.eyeBlink = undefined;

    let lerpAmount = 0.5;

    coreModel.setParameterValueById(
      'ParamAngleX',
      Vector.lerp(faceValue[1], coreModel.getParameterValueById('ParamAngleX'), lerpAmount),
    );
    coreModel.setParameterValueById(
      'ParamAngleY',
      Vector.lerp(faceValue[0], coreModel.getParameterValueById('ParamAngleY'), lerpAmount),
    );
    coreModel.setParameterValueById(
      'ParamAngleZ',
      Vector.lerp(faceValue[2], coreModel.getParameterValueById('ParamAngleZ'), lerpAmount),
    );

    coreModel.setParameterValueById(
      'ParamMouthOpenY',
      Vector.lerp(faceValue[4] * 1.7, coreModel.getParameterValueById('ParamMouthOpenY'), 0.2),
    );

    coreModel.setParameterValueById(
      'ParamMouthForm',
      Vector.lerp(faceValue[3] * 10, coreModel.getParameterValueById('ParamMouthForm'), 0.2),
    );

    let stabilizedEyes = Face.stabilizeBlink(
      {
        l: Vector.lerp(faceValue[5], coreModel.getParameterValueById('ParamEyeLOpen'), 0.7),
        r: Vector.lerp(faceValue[6], coreModel.getParameterValueById('ParamEyeROpen'), 0.7),
      },
      faceValue[7],
    );

    // eye blink
    coreModel.setParameterValueById('ParamEyeLOpen', stabilizedEyes.l);
    coreModel.setParameterValueById('ParamEyeROpen', stabilizedEyes.r);
  }, [faceValue]);

  return false;
}
